<template>
    <div class="mb-8">

        <div class="mb-2">
            <label @click="set('sometimes')" class="cursor-pointer uppercase border border-grey block text-center p-4"
                   :class="{'bg-purple-200': value === 'sometimes'}">
                <input class="invisible" name="desk_required" type="radio"
                       value="no">
                Schreibtisch Nachfrager
            </label>
        </div>

        <div class="mb-2">
            <label @click="set('none')" class="cursor-pointer uppercase border border-grey block text-center p-4"
                   :class="{'bg-purple-200': value === 'none'}">
                <input class="invisible" name="desk_required" type="radio"
                       value="yes">
                Schreibtisch Anbieter
            </label>
        </div>

    </div>
</template>

<script>
    export default {
        name: "TenantOrOwner",

        props: ["value"],

        methods: {
            set(value) {
                this.$emit("input", value)
            }
        }
    }
</script>

<style scoped>

</style>
